import { useState, useEffect } from "react";
import { M_URL, MAIN_URL } from "../../constants";
import api from '../../Components/RefreshToken/RefreshToken';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import AutoContinuePanel from "./autoContinue/AutoContinuePanel";
import AutoContinueBadge from "./autoContinue/AutoContinueBadge";

const getAuthHeaders = () => {
    const token = localStorage.getItem("admin_token");
    return {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
};

const statusColors = {
    completed: { bg: "#dcfce7", text: "#16a34a", dot: "#22c55e" },
    failed: { bg: "#fee2e2", text: "#dc2626", dot: "#ef4444" },
    canceled: { bg: "#fef9c3", text: "#ca8a04", dot: "#eab308" },
    processing: { bg: "#e0f2fe", text: "#0284c7", dot: "#38bcd8" },
};

function StatusBadge({ status }) {
    const s = statusColors[status] || statusColors.processing;
    return (
        <span
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "3px 10px",
                borderRadius: 999,
                fontSize: 12,
                fontWeight: 600,
                background: s.bg,
                color: s.text,
            }}
        >
            <span
                style={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    background: s.dot,
                    flexShrink: 0,
                }}
            />
            {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
    );
}

function formatDate(dateStr) {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    return d.toLocaleString("uz-UZ", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
}

const FILTERS = [
    { label: "Hammasi", value: "all" },
    { label: "Processing", value: "processing" },
    { label: "Completed", value: "completed" },
    { label: "Failed", value: "failed" },
    { label: "Canceled", value: "canceled" },
    { label: "Navbatda", value: "pending" },
];

// Bir sahifadagi videolar soni (so'rov limiti, skip va sahifalash shundan hisoblanadi)
const PAGE_SIZE = 12;

export default function GeneratingHistory() {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [savingIds, setSavingIds] = useState({});
    const [skip, setSkip] = useState(0);
    const [avatarMap, setAvatarMap] = useState({});
    const [statusFilter, setStatusFilter] = useState("all");
    const TOKEN = localStorage.getItem("admin_token");
    const navigate = useNavigate();

    useEffect(() => {
        const languages = ["en", "uz", "ru"];
        const fetchAllAvatars = async () => {
            const map = {};
            for (const lang of languages) {
                try {
                    const res = await api.get(`${MAIN_URL}/management/mentor/avatar`, {
                        headers: {
                            accept: "application/json",
                            Authorization: `Bearer ${TOKEN}`,
                        },
                        params: { language: lang },
                    });
                    const list = res.data || [];
                    list.forEach((item) => {
                        if (item.id && item.mentor) {
                            map[item.id] = `${item.mentor.first_name} ${item.mentor.last_name}`;
                        }
                    });
                } catch (err) {
                    console.log(`Avatar yuklashda xatolik (${lang}):`, err);
                }
            }
            setAvatarMap(map);
        };
        fetchAllAvatars();
    }, [TOKEN]);

    const fetchHistory = async (skipVal = 0, status = statusFilter) => {
        setLoading(true);
        setError(null);
        try {
            const params = new URLSearchParams({ skip: skipVal, limit: PAGE_SIZE });
            if (status !== "all") params.append("status", status);

            const res = await fetch(`${M_URL}/generatings-history?${params}`, {
                headers: getAuthHeaders(),
            });
            if (!res.ok) {
                if (res.status === 401) throw new Error("Token noto'g'ri yoki muddati tugagan (401)");
                throw new Error(`Server xatosi: ${res.status}`);
            }
            const data = await res.json();
            setItems(data.result || []);
            setTotal(data.total_count || 0);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Filter yoki skip o'zgarganda qayta fetch
    useEffect(() => {
        fetchHistory(skip, statusFilter);
    }, [skip, statusFilter]);

    // Filter o'zgarganda sahifani 0 ga qaytarish
    const handleFilterChange = (value) => {
        setStatusFilter(value);
        setSkip(0);
    };

    const totalPages = Math.ceil(total / PAGE_SIZE);
    const currentPage = Math.floor(skip / PAGE_SIZE) + 1;

    const handleSave = (videoUrl) => {
        localStorage.setItem("videoUrl", videoUrl);
        navigate("/preview");
    };
    const handleViewStatus = (taskId) => {
        localStorage.setItem("taskId", taskId);
        navigate("/status");
    };
    const watchPages = (taskId) => {
        localStorage.setItem("taskId", taskId);
        navigate("/watch-video");
    };
    const handleContinue = (taskId) => {
        axios.post(
            `${M_URL}/video-generate/continue/${taskId}`,
            {},
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${TOKEN}`,
                },
            }
        )
            .then((res) => {
                fetchHistory(skip, statusFilter);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleCancelGenerate = (taskId) => {
    axios.delete(`${M_URL}/video-generate/cancel/${taskId}`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        },
    })
    .then((res) => {
        navigate("/history");
        fetchHistory(skip, statusFilter);
    })
    .catch((err) => {
        console.log(err);
    });
};


    return (
        <div style={styles.page}>
            <div style={styles.container}>
                {/* Header */}
                <div style={styles.header}>
                    <div>
                        <h1 style={styles.title}>Yaratishlar tarixi</h1>
                        <p style={styles.subtitle}>
                            Jami{" "}
                            <strong style={{ color: "#6366f1" }}>{total}</strong> ta yaratilgan
                        </p>
                    </div>
                    <button
                        style={styles.refreshBtn}
                        onClick={() => fetchHistory(skip, statusFilter)}
                        disabled={loading}
                    >
                        {loading ? (
                            <span style={styles.spinner} />
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                <path d="M3 12a9 9 0 0 1 15-6.7L21 8M21 12a9 9 0 0 1-15 6.7L3 16" />
                                <path d="M21 3v5h-5M3 21v-5h5" />
                            </svg>
                        )}
                        Yangilash
                    </button>
                </div>

                <AutoContinuePanel />

                {/* Status filter tugmalari */}
                <div style={styles.filterRow}>
                    {FILTERS.map((f) => (
                        <button
                            key={f.value}
                            style={statusFilter === f.value ? styles.filterBtnActive : styles.filterBtn}
                            onClick={() => handleFilterChange(f.value)}
                        >
                            {f.label}
                        </button>
                    ))}
                </div>

                {/* Content */}
                {error ? (
                    <div style={styles.errorBox}>
                        <span>⚠️ {error}</span>
                        <button style={styles.retryBtn} onClick={() => fetchHistory(skip, statusFilter)}>
                            Qayta urinish
                        </button>
                    </div>
                ) : loading ? (
                    <div style={styles.loadingBox}>
                        <div style={styles.spinnerLarge} />
                        <p style={{ color: "#94a3b8", marginTop: 16 }}>Yuklanmoqda...</p>
                    </div>
                ) : items.length === 0 ? (
                    <div style={styles.emptyBox}>
                        <div style={styles.emptyIcon}>📭</div>
                        <p style={{ color: "#64748b", fontWeight: 500 }}>
                            {statusFilter === "all"
                                ? "Hali yaratilgan videolar yo'q"
                                : "Bu statusda video topilmadi"}
                        </p>
                    </div>
                ) : (
                    <>
                        <div style={styles.grid}>
                            {items.map((item) => (
                                <div key={item.task_id} style={styles.card}>
                                    {item.video_url ? (
                                        <div style={styles.videoWrap}>
                                            <video
                                                src={item.video_url}
                                                style={styles.video}
                                                controls
                                                preload="metadata"
                                            />
                                        </div>
                                    ) : (
                                        <div style={styles.videoPlaceholder}>
                                            <span style={{ fontSize: 36 }}>🎬</span>
                                        </div>
                                    )}

                                    <div style={styles.cardBody}>
                                        <div style={styles.cardRow}>
                                            <StatusBadge status={item.status} />
                                            {item.lang && (
                                                <span style={styles.langBadge}>
                                                    {item.lang.toUpperCase()}
                                                </span>
                                            )}
                                            {item.status === "failed" && <AutoContinueBadge task={item} />}
                                        </div>

                                        <div style={styles.infoGrid}>
                                            <InfoRow label="Task ID" value={
                                                <span style={styles.mono}>{item.task_id}</span>
                                            } />
                                            {item.avatar_id && (
                                                <InfoRow
                                                    label="Avatar"
                                                    value={
                                                        avatarMap[item.avatar_id]
                                                            ? avatarMap[item.avatar_id]
                                                            : <span style={styles.mono}>{item.avatar_id}</span>
                                                    }
                                                />
                                            )}
                                            {item.completed_at && (
                                                <InfoRow label="Tugallangan" value={formatDate(item.completed_at)} />
                                            )}
                                            {item.current_page != null && (
                                                <InfoRow label="Sahifa" value={`${item.current_page}`} />
                                            )}
                                        </div>

                                        {item.status === "processing" && (
                                            <button
                                                style={styles.viewStatusBtn}
                                                onClick={() => handleViewStatus(item.task_id)}
                                            >
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <polyline points="12 6 12 12 16 14" />
                                                </svg>
                                                Holatni ko'rish
                                            </button>
                                        )}

                                        {item.status === "failed" || item.status === "canceled" ? (
                                            <button onClick={() => handleContinue(item.task_id)} style={styles.continueBtn}>Davom etish</button>
                                        ) : null}

                                        {item.status === "completed" && (
                                            <button
                                                style={styles.viewStatusBtn}
                                                onClick={() => watchPages(item.task_id)}
                                            >
                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <polyline points="12 6 12 12 16 14" />
                                                </svg>
                                                Sahifalarni ko'rish
                                            </button>
                                        )}

                                        {item.status === "processing" && (
                                            <button onClick={() => handleCancelGenerate(item.task_id)} style={{ ...styles.cancelBtnStyle }} >Cancel</button>
                                        )}

                                        {item.status === "completed" && !item.is_saved && (
                                            <button
                                                style={{
                                                    ...styles.saveBtn,
                                                    opacity: item.video_url == null ? 0.7 : 1,
                                                    cursor: savingIds[item.task_id] ? "not-allowed" : "pointer",
                                                }}
                                                onClick={() => handleSave(item.video_url)}
                                                disabled={item.video_url == null}
                                            >
                                                {savingIds[item.task_id] ? (
                                                    <>
                                                        <span style={{ ...styles.spinner, borderTopColor: "#fff" }} />
                                                        Saqlanmoqda...
                                                    </>
                                                ) : (
                                                    <>
                                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                                                            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
                                                            <polyline points="17 21 17 13 7 13 7 21" />
                                                            <polyline points="7 3 7 8 15 8" />
                                                        </svg>
                                                        Saqlash
                                                    </>
                                                )}
                                            </button>
                                        )}

                                        {item.status === "completed" && item.is_saved && (
                                            <div style={styles.savedTag}>
                                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2.5">
                                                    <polyline points="20 6 9 17 4 12" />
                                                </svg>
                                                Saqlangan
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        {totalPages > 1 && (
                            <div style={styles.pagination}>
                                <button
                                    style={styles.pageBtn}
                                    disabled={skip === 0}
                                    onClick={() => setSkip(Math.max(0, skip - PAGE_SIZE))}
                                >
                                    ← Oldingi
                                </button>
                                <span style={styles.pageInfo}>
                                    {currentPage} / {totalPages}
                                </span>
                                <button
                                    style={styles.pageBtn}
                                    disabled={skip + PAGE_SIZE >= total}
                                    onClick={() => setSkip(skip + PAGE_SIZE)}
                                >
                                    Keyingi →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

function InfoRow({ label, value }) {
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                {label}
            </span>
            <span style={{ fontSize: 13, color: "#334155" }}>{value}</span>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        background: "#f8fafc",
        fontFamily: "'Inter', 'Segoe UI', sans-serif",
        padding: "32px 16px",
    },

    cancelBtnStyle: {
        display: "inline-block",
        alignItems: "center",
        gap: "6px",
        height: "32px",
        padding: "0 12px",
        fontSize: "13px",
        fontWeight: 500,
        color: "#fff",
        background: "#e24b4a",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
        // marginTop: "30px",
    },
    container: {
        maxWidth: 1100,
        margin: "0 auto",
    },
    header: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        marginBottom: 28,
        gap: 16,
        flexWrap: "wrap",
    },
    title: {
        fontSize: 26,
        fontWeight: 700,
        color: "#0f172a",
        margin: 0,
    },
    subtitle: {
        fontSize: 14,
        color: "#64748b",
        marginTop: 4,
        fontWeight: 400,
    },
    refreshBtn: {
        display: "flex",
        alignItems: "center",
        gap: 7,
        padding: "8px 16px",
        borderRadius: 8,
        border: "1px solid #e2e8f0",
        background: "#fff",
        color: "#475569",
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
        transition: "all 0.15s",
    },
    filterRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        marginBottom: 24,
        flexWrap: "wrap",
    },
    filterBtn: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "7px 16px",
        borderRadius: 999,
        border: "1px solid #e2e8f0",
        background: "#fff",
        color: "#475569",
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
        transition: "all 0.15s",
    },
    filterBtnActive: {
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "7px 16px",
        borderRadius: 999,
        border: "1px solid #6366f1",
        background: "#6366f1",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
        cursor: "pointer",
        transition: "all 0.15s",
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(min(300px, 100%), 1fr))",
        gap: 20,
    },
    card: {
        background: "#fff",
        borderRadius: 14,
        border: "1px solid #e2e8f0",
        overflow: "hidden",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
        transition: "box-shadow 0.2s",
    },
    videoWrap: {
        background: "#0f172a",
        aspectRatio: "16/9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    video: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
    },
    videoPlaceholder: {
        background: "#f1f5f9",
        aspectRatio: "16/9",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    cardBody: {
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: 12,
    },
    cardRow: {
        display: "flex",
        alignItems: "center",
        gap: 8,
        flexWrap: "wrap",
    },
    langBadge: {
        fontSize: 11,
        fontWeight: 700,
        padding: "3px 8px",
        borderRadius: 6,
        background: "#f1f5f9",
        color: "#475569",
        letterSpacing: "0.05em",
    },
    infoGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: 10,
    },
    mono: {
        fontFamily: "monospace",
        fontSize: 12,
        background: "#f8fafc",
        padding: "1px 5px",
        borderRadius: 4,
        color: "#6366f1",
        wordBreak: "break-all",
    },
    saveBtn: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "9px 0",
        borderRadius: 8,
        border: "none",
        background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
        width: "100%",
        transition: "all 0.15s",
    },
    viewStatusBtn: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "9px 0",
        borderRadius: 8,
        border: "none",
        background: "linear-gradient(135deg, #38bcd8 0%, #0284c7 100%)",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
        width: "100%",
        cursor: "pointer",
        transition: "all 0.15s",
    },
    savedTag: {
        display: "flex",
        alignItems: "center",
        gap: 5,
        fontSize: 12,
        fontWeight: 600,
        color: "#16a34a",
        padding: "7px 0",
        justifyContent: "center",
        background: "#dcfce7",
        borderRadius: 8,
    },
    loadingBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "80px 0",
    },
    emptyBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "80px 0",
        gap: 8,
    },
    emptyIcon: {
        fontSize: 48,
        marginBottom: 8,
    },
    errorBox: {
        background: "#fee2e2",
        border: "1px solid #fecaca",
        borderRadius: 10,
        padding: "16px 20px",
        color: "#dc2626",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 12,
        flexWrap: "wrap",
    },
    retryBtn: {
        padding: "6px 14px",
        borderRadius: 6,
        border: "1px solid #dc2626",
        background: "#fff",
        color: "#dc2626",
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
    },
    spinner: {
        display: "inline-block",
        width: 14,
        height: 14,
        border: "2px solid rgba(255,255,255,0.3)",
        borderTop: "2px solid #fff",
        borderRadius: "50%",
        animation: "spin 0.7s linear infinite",
    },
    spinnerLarge: {
        width: 40,
        height: 40,
        border: "3px solid #e2e8f0",
        borderTop: "3px solid #6366f1",
        borderRadius: "50%",
        animation: "spin 0.7s linear infinite",
    },
    pagination: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        marginTop: 32,
    },
    pageBtn: {
        padding: "8px 20px",
        borderRadius: 8,
        border: "1px solid #e2e8f0",
        background: "#fff",
        color: "#475569",
        fontSize: 13,
        fontWeight: 500,
        cursor: "pointer",
    },
    pageInfo: {
        fontSize: 14,
        color: "#64748b",
        fontWeight: 500,
    },
    continueBtn: {
        // display: "inline-flex",
        // alignItems: "center",
        gap: "6px",
        height: "32px",
        padding: "0 12px",
        fontSize: "13px",
        fontWeight: 500,
        color: "#0c447c",
        background: "#e6f1fb",
        border: "0.5px solid #85b7eb",
        borderRadius: "6px",
        cursor: "pointer",
    },
};